import React from 'react';
import { Box } from '@material-ui/core';
import { HeadCell, Typography } from '../../../../ui-kit';
import { IncompleteDataDisclaimer } from '../../../shared';
import NameCell, { NameCellProps } from '../NameCell';
import { Row } from './types';


interface TableCellContentProps extends NameCellProps {
    id: keyof Row;
    productWithNoRecipeCount: number;
    align: HeadCell['align'];
}

const TableCellContent = ({
    id,
    content,
    color,
    hasCollapsibleContent,
    isOpen, setIsOpen,
    isChild,
    productWithNoRecipeCount,
    align,
}: TableCellContentProps) => {
    if (id === 'name') {
        return (
            <NameCell
                hasCollapsibleContent={hasCollapsibleContent}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                content={content}
                color={color}
                isChild={isChild}
            />
        );
    }

    let cellContent: React.ReactNode = <Typography align={align} variant='body2'>{content}</Typography>;

    if (id === 'foodCost' || id === 'netMargin') {
        cellContent = (
            <Box display='flex' justifyContent={align} alignItems='center'>
                <IncompleteDataDisclaimer productWithNoRecipeCount={productWithNoRecipeCount} />
                {cellContent}
            </Box>
        );
    }
    return (
        <>
            {cellContent}
        </>
    );
};

export default TableCellContent;